import {MOON_650, MOON_950} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Message = styled.div`
  text-align: center;
  max-width: 600px;
  font-size: 18px;
  line-height: 30px;
  margin-bottom: 16px;
  font-style: italic;
`;
Message.displayName = 'S.Message';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 18px;
`;
Container.displayName = 'S.Container';

export const EmptyTitle = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: ${MOON_950};
  margin-top: 64px;
`;
EmptyTitle.displayName = 'S.EmptyTitle';

export const EmptyMessage = styled.div`
  text-align: center;
  color: ${MOON_650};
  margin-top: 8px;
`;
EmptyMessage.displayName = 'S.EmptyMessage';
